import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandSVG = (
  <svg viewBox="0 0 32 31" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.166 9.71c.11.11.44.11.551 0 .773-.33 1.545-.772 2.317-1.213.773-.442 1.545-.773 2.318-1.214-.11 0-.11-.11-.11-.11-4.194-2.097-8.497-4.194-12.69-6.29a.336.336 0 00-.442 0c-1.544.772-3.2 1.545-4.855 2.427.11.11.22.11.22.11 4.304 2.097 8.497 4.194 12.69 6.29zm-9.38 5.738c-4.414-2.207-8.938-4.414-13.352-6.73-.11-.111-.33-.111-.44-.221v14.896c0 .331.11.441.33.552 4.524 2.207 9.048 4.524 13.573 6.73.11 0 .22.111.33.111v-.22V15.89c0-.221-.22-.331-.44-.442zm7.173-4.634c-4.193-1.986-8.497-4.083-12.69-6.07a.703.703 0 00-.662 0L3.64 7.063c-.11.11-.22.22-.441.331.11 0 .11.11.11.11C7.503 9.6 11.807 11.697 16 13.793c.11.11.331.11.552 0a261.591 261.591 0 005.738-2.759c-.11-.11-.221-.11-.331-.22zm9.71-1.876v-.441c-.11.11-.22.11-.331.11-1.876.993-3.862 1.876-5.738 2.869v5.407l-1.986.993v-5.297c-1.876.993-3.862 1.876-5.738 2.87-.331.11-.331.33-.331.661v14.897c.11-.11.22-.11.22-.11 4.525-2.318 9.16-4.525 13.683-6.842.331-.11.331-.33.331-.552-.11-4.965-.11-9.71-.11-14.565z"
      fill="#7D7E7E"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: CrossBrandSVG,
  [Brands.BananaRepublic]: CrossBrandSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSVG,
  [Brands.Gap]: CrossBrandSVG,
  [Brands.GapFactoryStore]: CrossBrandSVG,
  [Brands.OldNavy]: CrossBrandSVG,
  crossBrand: CrossBrandSVG,
};

export const ValueDrawerShippingIcon = (
  props: IconContainerProps
): JSX.Element => <Icon {...props} brandIconSVGs={brandIconSVGs} />;
